var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sideNav"},[_c('ul',{staticClass:"h-auto sidebar d-lg-block d-flex align-items-center justify-content-around justify-content-between sidebar w-100 pb-lg-5",attrs:{"id":"navItems"}},_vm._l((_vm.sideRoutes),function(element,i){return _c('SideNavItem',{key:i,attrs:{"index":i,"elements":_vm.sideRoutes,"element":element}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }